module.exports = __webpack_public_path__ + "static/img/sv.c55a75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/sv.png
// module id = b0wQ
// module chunks = 18